import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInvoiceinline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.15,
		d: "M3.75 12.75V3.432a.75.75 0 0 1 .374-.649l.745-.431a.75.75 0 0 1 .75-.002l1.128.648L6.75 3l1.12-.65a.75.75 0 0 1 .748 0l1.129.648h.006l1.129-.648a.75.75 0 0 1 .75.002l1.115.646h.006l1.129-.648a.75.75 0 0 1 .75.001l.744.432a.75.75 0 0 1 .374.649v11.193c0 .621-.504 1.125-1.125 1.125v0a1.125 1.125 0 0 1-1.125-1.125V13.5a.75.75 0 0 0-.75-.75H3a.75.75 0 0 0-.75.75v.75a1.5 1.5 0 0 0 1.5 1.5h10.875M9.75 9.375H6.753M9.75 6.75H6.753m5.997 2.625H12m.75-2.625H12"
	})
});
export default SvgInvoiceinline;
